"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDx = parseDx;
const CPATH_INSTANCE_ID = /\\I(\d+)\\/;
function parseDx(text) {
    const raw = JSON.parse(text);
    const rawInstances = Array.isArray(raw['instances']) ? raw['instances'] : [];
    const instances = [];
    const instancesByXconId = new Map();
    for (const rawInst of rawInstances) {
        if (typeof rawInst !== 'object' || rawInst === null) {
            continue;
        }
        const inst = rawInst;
        const cpath = typeof inst['cpath'] === 'string' ? inst['cpath'] : '';
        const xconInstanceId = extractXconInstanceId(cpath);
        const rawProps = inst['properties'];
        const properties = typeof rawProps === 'object' && rawProps !== null ? normalizeStringMap(rawProps) : {};
        const rawAttrs = inst['attributes'];
        const attrsMap = typeof rawAttrs === 'object' && rawAttrs !== null ? normalizeStringMap(rawAttrs) : {};
        const attributes = {
            refdes: attrsMap['refdes'] ?? '',
            symbol: attrsMap['symbol'] ?? '',
            HASHID: attrsMap['HASHID'] ?? '',
            library: attrsMap['library'] ?? '',
            system_capture_model: attrsMap['system_capture_model'] ?? '',
            partid: attrsMap['partid'] ?? '',
        };
        const dxInstance = { cpath, xconInstanceId, properties, attributes };
        instances.push(dxInstance);
        if (xconInstanceId.length > 0) {
            instancesByXconId.set(xconInstanceId, dxInstance);
        }
    }
    return { instances, instancesByXconId };
}
function extractXconInstanceId(cpath) {
    const match = CPATH_INSTANCE_ID.exec(cpath);
    return match !== null ? `I${match[1]}` : '';
}
function normalizeStringMap(obj) {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
        if (typeof v === 'string') {
            out[k] = v;
        }
        else if (typeof v === 'number' || typeof v === 'boolean') {
            out[k] = String(v);
        }
    }
    return out;
}
//# sourceMappingURL=dxJsonParser.js.map